import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UserService } from '../../../core/services/user.service';

@Component({
  selector: 'app-admin-users',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './admin-users.html',
  styleUrls: ['../admin-companies/admin-companies.scss','./admin-users.scss']
})
export class AdminUsers implements OnInit {
  users: any[] = [];
  filteredUsers: any[] = [];
  
  searchTerm = '';
  filterType = '';
  filterPlan = '';

  stats = { total: 0, active: 0, pro: 0, premium: 0 };

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.loadUsers();
  }

  loadUsers() {
    this.userService.getAllUsers().subscribe(users => {
      this.users = users;
      this.applyFilters();
      this.calculateStats();
    });
  }

  applyFilters() {
    let filtered = [...this.users];
    if (this.searchTerm) {
      filtered = filtered.filter(u => 
        u.firstName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        u.lastName.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        u.email.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    }
    if (this.filterType) filtered = filtered.filter(u => u.userType === this.filterType);
    if (this.filterPlan) filtered = filtered.filter(u => u.userPlan.planName === this.filterPlan);
    this.filteredUsers = filtered;
  }

  onSearch() { this.applyFilters(); }

  resetFilters() {
    this.searchTerm = '';
    this.filterType = '';
    this.filterPlan = '';
    this.applyFilters();
  }

  calculateStats() {
    this.stats.total = this.users.length;
    this.stats.active = this.users.filter(u => u.isActif).length;
    this.stats.pro = this.users.filter(u => u.userType === 'pro').length;
    this.stats.premium = this.users.filter(u => u.userPlan.planName === 'premium').length;
  }

  // viewUser(user: any) { console.log('View:', user); }

  // editUser(user: any) { console.log('Edit:', user); }
  
  toggleUserStatus(user: any) {
    const action = user.isActif ? 'suspendre' : 'activer';
    if (confirm(`Voulez-vous ${action} cet utilisateur ?`)) {
      user.isActif = !user.isActif;
      const service = user.isActif 
        ? this.userService.activateUser(user._id) 
        : this.userService.suspendUser(user._id);
      service.subscribe(() => this.calculateStats());
    }
  }

  deleteUser(user: any) {
    if (confirm(`Supprimer l'utilisateur ${user.firstName} ${user.lastName} ? Cette action est irréversible.`)) {
      this.userService.deleteUser(user._id).subscribe(() => this.loadUsers());
    }
  }

  exportData() { console.log('Export'); }
}

